import { render, staticRenderFns } from "./MyProfileEdit.vue?vue&type=template&id=2b4906b8&scoped=true"
import script from "./MyProfileEdit.vue?vue&type=script&lang=ts"
export * from "./MyProfileEdit.vue?vue&type=script&lang=ts"
import style0 from "./MyProfileEdit.vue?vue&type=style&index=0&id=2b4906b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4906b8",
  null
  
)

export default component.exports